import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {nodeEmitter} from '../../services/flowBuilder/utils/locaction-calculator-interface';
import {DeleteStepData} from '../../services/flowBuilder/models';
import {FlowWebSocketsService} from '../../services/flowBuilder/flow-web-sockets.service';
import {SharedService} from '../../../../core/services/store/shared-store/shared-storage.service';

import {EditPermissions, NodeBuilder, NodeFlowDetails, Step} from '../../../../shared/models';
import {map, take} from 'rxjs/operators';
import {FlowManagerService} from '../../services/flow-manager.service';
import {Subscription} from 'rxjs';
import {RolesService} from '../../../../core/services/roles/roles.service';
import {EditTypes, getEditTypes} from './delegatorUtils';
import {UserStoreService} from '../../../../core/services/store/UserStore/user-store.service';
import {FlowBuilderService} from '../../services/flowBuilder/flow-builder.service';
import {MatDialog} from '@angular/material/dialog';
import {ActiveFormService} from '../../services/active-form.service';
import {swalMini} from '../../../../shared/utils/utils';
import {Store} from '@ngrx/store';
import {selectNodeTypesMap} from '../../../../core/state/selectors/flow.selector';
import cloneDeep from 'lodash/cloneDeep';
import assign from 'lodash/assign';
import {menuTypes} from '../json-to-from/types/menu/menu';
import {actionTypes} from '../json-to-from/types/actions/action';
import {integration} from '../json-to-from/types/integration/integration';
import {AnalyticsSettingsComponent} from './nodes/templates/analytics-settings/analytics-settings.component';
import {CollectionService} from '../../../analytics-settings/services/collection.service';
import isEmpty from 'lodash/isEmpty';
import {NodeObject} from '../../../../shared/utils/nodeTypes';
import {WhatsAppSettingsComponent} from './nodes/templates/whats-app-settings/whats-app-settings.component';

const MENU_FORM_TITLE = 'Send Form';
const CHAT_2_PAY_TITLE = 'Chat 2 Pay';
const CONTACT_RECEIVING = 'Contact Receiving';
const CONTACT_SENDING = 'Contact Sending';
const SEND_TEMPLATE = 'Send Template';
const MENUS = menuTypes;
const ACTIONS = actionTypes;
const INTEGRATION = integration;

enum overlayType {
    ANALYTICS = 'analytics',
    WHATSAPP = 'whatsapp',
}

@Component({
    selector: 'node-delegator',
    templateUrl: './node-delegator.component.html',
    styleUrls: ['./node-delegator.component.scss'],
})
export class NodeDelegatorComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

    public currentNodeType: NodeObject;
    public stepNumber: string;
    protected readonly overlayType = overlayType;

    constructor(public flowWebSocket: FlowWebSocketsService,
                public sharedService: SharedService,
                private cd: ChangeDetectorRef,
                private flowManagerService: FlowManagerService,
                private rolesService: RolesService,
                private flowBuilder: FlowBuilderService,
                private userStore: UserStoreService,
                private activeFormService: ActiveFormService,
                private collectionService: CollectionService,
                public dialog: MatDialog,
                private store: Store) {
    }

    @Input() stepInfo: nodeEmitter;
    @Input() isRecycleBin: boolean;
    @Input() currentFlowSteps: string[];
    @Output() saveNode = new EventEmitter<Object>();
    @Output() deleteNode = new EventEmitter<DeleteStepData>();
    @Output() resetNode = new EventEmitter();
    @ViewChild('analyticsSettings') analyticsSettingsOverlay: AnalyticsSettingsComponent;
    @ViewChild('whatsAppSettings') whatsAppSettingsOverlay: WhatsAppSettingsComponent;

    @ViewChild('node') node: NodeBuilder;
    @ViewChild('deleteParentNodeDialog', {static: true}) deleteParentNodeDialog: TemplateRef<any>;

    currentSelectedStep: Step = null;
    nodeType: string;
    stepId: string;
    nodeTitle: string;

    nodeFlowDetails: NodeFlowDetails = {
        flows: undefined,
        currentFlowSteps: undefined,
        extraFields: {},
        stepId: '',
    };

    private flowSubscription: Subscription;
    isFlowLocked: boolean;

    editTypes: EditTypes;

    displayMessage: Boolean;
    childCount: number;
    nodeTypes: any = assign({}, cloneDeep(MENUS), cloneDeep(ACTIONS), cloneDeep(INTEGRATION));
    isOpen: Boolean = false;
    isCurrentEnvProd: boolean;
    public settingsData: any;
    private waSettingsData: any;

    async ngOnInit() {
        const flows = await this.flowManagerService.getFlows_with_ids(true).toPromise();

        this.nodeFlowDetails.flows = flows;
        this.nodeFlowDetails.currentFlowSteps = this.currentFlowSteps;
        if (this.node) {
            this.node.nodeFlowDetails = this.nodeFlowDetails;
        }
        this.setStepNumber();
        this.getNodeIcons();
        this.isCurrentEnvProd = this.isProdEnv;
    }

    ngOnDestroy(): void {
        this.flowSubscription?.unsubscribe();
        this.activeFormService.clearActiveForm();
    }

    ngAfterViewInit() {
        this.addStep();
        if (!this.node) {
            return;
        } // This point on is for NEW DELEGATOR Nodes (only runs once)
        if (this.node.nodeFlowDetails) {
            this.node.nodeFlowDetails.extraFields = this.stepInfo?.extraFields;
            this.node.nodeFlowDetails.lastStepNumber = this.flowBuilder.getLastStepNumber();
        } else {
            this.node.nodeFlowDetails = {
                ...this.nodeFlowDetails,
                lastStepNumber: this.flowBuilder.getLastStepNumber(),
            };
        }
        this.editTypes = getEditTypes(this.canEdit);
        this.node.canEdit = this.canEdit;
        this.node.getStepUniqueID(this.stepInfo.step);
        this.node.buildForm = this.stepInfo.step;
        let nodeData = this.node.getStepData;
        nodeData = this.node.setStepUniqueID(nodeData);
        if (this.stepInfo.step['metadata']?.reportingFeatures) {
            nodeData['metadata'].reportingFeatures = this.stepInfo.step['metadata'].reportingFeatures;
        }
        if (this.stepInfo.step['metadata']?.reportingLabels) {
            nodeData['metadata'].reportingLabels = this.stepInfo.step['metadata'].reportingLabels;
        }

        if (this.stepInfo.step['metadata']?.conversion) {
            nodeData['metadata'].conversion = this.stepInfo.step['metadata'].conversion;
        }

        if (!this.isRecycleBin) {
            this.flowBuilder.addStep(this.stepId, nodeData as Step);
            this.flowBuilder.setNodeValid(this.nodeFlowDetails.stepId, this.node.isNodeValid);
        }
    }

    getNodeIcons() {
        this.store.select(selectNodeTypesMap)
            .pipe(
                take(1),
                map(nodeObjects => {
                    switch (this.nodeType) {
                        case 'chatHub':
                            const providerId = this.stepInfo.extraFields['providerId'] ? this.stepInfo.extraFields['providerId'] : this.stepInfo.step['action']['actionParams']['chathub']['providerId'];
                            return nodeObjects[providerId];
                        default:
                            return nodeObjects[this.nodeType];
                    }
                }),
            )
            .subscribe(nodeObjects => this.currentNodeType = nodeObjects);
    }

    ngOnChanges(): void {
        this.nodeType = this.stepInfo.nodeType;
        this.stepId = this.stepInfo.id;
        this.nodeFlowDetails.stepId = this.stepId;
        this.getNodeIcons();

        this.nodeTitle = this.getNodeTitle();
        this.setStepAnalyticSettings(this.stepInfo.step);
        this.waSettingsData = this.stepInfo.step['metadata']?.conversion || null;
    }

    private addStep(): void {
        if (!this.stepInfo.step) {
            this.currentSelectedStep = {} as Step;
            this.stepInfo.step = {} as Step;
        }

        // This should be for steps that are already saved (selected node)
        if (this.stepInfo.step && Object.keys(this.stepInfo.step).length) {
            this.currentSelectedStep = this.stepInfo.step as Step;
            return;
        }
        // New node: this.node should only be available for Node Components that implement NodeBuilder
        if (!this.node) {
            const stepJson = cloneDeep(this.nodeTypes[this.nodeType].json);
            this.flowBuilder.addStep(this.stepId, stepJson);
            this.currentSelectedStep = stepJson;
        }
    }

    setStepNumber() {
        if (this.stepId === 'start') {
            return;
        }
        this.stepNumber = this.stepId.match(/\d/g).join('');
        if (this.stepNumber.length > 7) {
            this.stepNumber = this.stepNumber.substring(0, 7) + '...';
        }
    }

    getNodeTitle() {
        // TODO: switch case is not needed
        switch (this.nodeType) {
            case 'multipleChoice':
            case 'waitForCallback':
            case 'dynamicList':
            case 'multiProduct':
            case 'setVariable':
            case 'switchCase':
                const title = this.nodeType[0].toUpperCase() + this.nodeType.substring(1);
                return title.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
            case 'menuForm':
                return MENU_FORM_TITLE;
            case 'chat2pay':
                return CHAT_2_PAY_TITLE;
            case 'contactSending':
                return CONTACT_SENDING;
            case 'contactReceiving':
                return CONTACT_RECEIVING;
            case 'decimalFormat':
                return 'Number Format';
            case 'sendTemplate':
                return SEND_TEMPLATE;
            default:
                return this.currentNodeType.title;
        }
    }

    clearActiveForm() {
        this.activeFormService.setNodeExit(false);
        this.activeFormService.clearActiveForm();
    }

    saveNodeClicked(step?: Object) {
        if (step) {
            this.saveNode.emit(step);
            this.clearActiveForm();
            return;
        }
        if (!this.node.isNodeValid) {
            this.showNodeValidationFailedModal();
            this.flowBuilder.setNodeValid(this.nodeFlowDetails.stepId, this.node.isNodeValid);
            return;
        }
        this.saveMigratedNode();
    }

    showNodeValidationFailedModal() {
        swalMini({
            title: 'Validation failed, please check for errors!',
            type: 'error',
        });
    }

    private saveMigratedNode() {
        this.sharedService.setIsFlowChanged(true);
        this.clearActiveForm();
        let dataToEmit = this.node.getStepData;
        dataToEmit = this.node.setStepUniqueID(dataToEmit);
        let nodeData = this.addAnalyticsSettings(dataToEmit);
        nodeData = this.addWaSettings(nodeData);
        this.saveNode.emit(nodeData);
    }

    addAnalyticsSettings(stepInfo) {
        if (!stepInfo.metadata) {
            stepInfo = {...stepInfo, metadata: {}};
        }
        if (stepInfo.metadata && this.settingsData) {
            if (!isEmpty(this.settingsData.reportingFeatures)) {
                stepInfo.metadata = {
                    ...stepInfo.metadata,
                    reportingFeatures: this.settingsData.reportingFeatures,
                };
            } else {
                delete stepInfo.metadata.reportingFeatures;
            }

            if (this.settingsData.reportingLabels !== '') {
                stepInfo.metadata = {
                    ...stepInfo.metadata,
                    reportingLabels: {
                        reportingStepLabel: this.settingsData.reportingLabels,
                    },
                };
            } else {
                if (!stepInfo.metadata.reportingLabels) {
                    delete stepInfo.metadata.reportingLabels;
                }
            }
        }

        return stepInfo;
    }

    setStepAnalyticSettings(stepData) {
        if (stepData?.metadata.reportingFeatures) {
            this.settingsData = {
                stepTitle: this.stepId,
                reportingFeatures: stepData.metadata.reportingFeatures,
                reportingLabels: stepData.metadata.reportingLabels?.reportingStepLabel,
            };
        } else if (stepData?.metadata.reportingLabels) {
            this.settingsData = {
                stepTitle: this.stepId,
                reportingLabels: stepData.metadata.reportingLabels?.reportingStepLabel,
            };
        }
    }

    updateAnalyticsSettings(updattedSettings) {
        this.settingsData = updattedSettings;
        this.closeOverlay(overlayType.ANALYTICS);
    }

    updateWaSettings(settings) {
        this.waSettingsData = settings;
        this.closeOverlay(overlayType.WHATSAPP);
    }

    addWaSettings(step) {
        if (!this.waSettingsData) {
            return step;
        }
        step.metadata['conversion'] = this.waSettingsData;
        return step;
    }


    openDeleteParentNodeDialog() {
        if (!this.isRecycleBin) {
            if (
                this.userStore.getMessageDisplay === null ||
                this.userStore.getMessageDisplay === undefined
            ) {
                this.userStore.setMessageDisplay = false;
            }

            this.displayMessage = this.userStore.getMessageDisplay;
            if (this.displayMessage) {
                this.childCount = this.flowBuilder.getChildrenCount(this.stepId);
                if (this.childCount > 0) {
                    this.dialog.open(this.deleteParentNodeDialog, {
                        panelClass: 'deleteParentNodeDialog',
                        width: '484px',
                        height: '365px',
                        disableClose: true,
                    });
                } else {
                    this.deleteNodeClicked(this.stepId);
                }
            } else {
                this.deleteNodeClicked(this.stepId);
            }
        } else {
            this.deleteNodeClicked(this.stepId);
        }
    }

    deleteNodeClicked(stepId: string) {
        const deleteStep: DeleteStepData = {
            stepId: stepId,
            parentId: this.stepInfo.parentId,
        };
        this.deleteNode.emit(deleteStep);
        this.dialog.closeAll();
    }

    setDisplay(event) {
        if (event.checked === undefined || event.checked === null) {
            this.userStore.setMessageDisplay = false;
        } else {
            this.userStore.setMessageDisplay = event.checked;
        }
    }

    get canEdit(): EditPermissions {

        this.isFlowLocked = this.flowWebSocket.isFlowLocked(this.sharedService.getFlowRef);
        const canEdit = !(this.isFlowLocked || this.sharedService.isDeletePending) && !this.isProdEnv;

        if (this.currentNodeType.permissions && this.currentNodeType.permissions.canEdit) {
            const hasPermission: boolean = this.rolesService.isUserInRoles(this.currentNodeType.permissions.canEdit);
            return {
                canEditFlows: hasPermission,
                canEditMenuTextOnly: hasPermission,
                canEdit: canEdit && hasPermission,
            };
        }

        return {
            canEditFlows: this.rolesService.canEditFlows(),
            canEditMenuTextOnly: this.rolesService.canEditMenuTextOnly(),
            canEdit: canEdit,
        };
    }

    get canSave(): boolean {
        return !((this.stepId !== 'start') && ((this.editTypes?.editMenuTextOnly && this.nodeType === 'menu') || this.editTypes?.editFlows));
    }

    get isProdEnv(): boolean {
        const env = this.sharedService.getEnvironment();
        return (env === 'production' || env === 'preprod' || env === 'prod');
    }

    openOverlay(overlay: overlayType) {
        this.isOpen = true;
        switch (overlay) {
            case overlayType.ANALYTICS:
                this.analyticsSettingsOverlay.analyticsSlider.nativeElement.style.right = '0%';
                break;
            case overlayType.WHATSAPP:
                this.whatsAppSettingsOverlay.slider.nativeElement.style.right = '0%';
                this.whatsAppSettingsOverlay.isOpen = true;
                break;
        }

    }

    closeOverlay(overlay: overlayType) {
        this.isOpen = false;
        switch (overlay) {
            case overlayType.ANALYTICS:
                this.analyticsSettingsOverlay.analyticsSlider.nativeElement.style.right = '-110%';
                break;
            case overlayType.WHATSAPP:
                this.whatsAppSettingsOverlay.slider.nativeElement.style.right = '-110%';
                break;
        }
    }

}
